export default "__VITE_ASSET__DKxw5kxj__"